/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// $(document).ready(function(){
//   $(".product-flex-slider").flickity({
//     wrapAround: true,
//     pageDots: false,
// 	   groupCells: 2,
//     accessibility: true,
//     autoPlay: 2650 
//   });
//   var $carousel = $('#galry_slider').flickity();
//   if (matchMedia('screen and (min-width: 768px)').matches) {
//     $carousel.on( 'dragStart.flickity', function() {
//       $(this).addClass('is-dragging');
//     });
//     $carousel.on( 'dragEnd.flickity', function() {
//       $(this).removeClass('is-dragging');
//     });
//   }
// });

$(document).ready(function() {
  $('.itg-product-slider').flexslider({
    animation: "slide",
    animationLoop: false,
    animation: 'slide',
    easing: 'linear',
    minItems: 2,
    maxItems: 2,
    itemWidth: 500,
    move: 1
  });
});

$(window).on('load',function(){
  $('.itg-product-slider').addClass('active');
  $('.hide-load').hide();
});

$(document).ready(function(){
  $("#galry_slider").flickity({
    wrapAround: true,
    pageDots: false,
    initialIndex: 1,
    accessibility: true,
    autoPlay: 2650 
  });
  var $carousel = $('#galry_slider').flickity();
  if (matchMedia('screen and (min-width: 768px)').matches) {
    $carousel.on( 'dragStart.flickity', function() {
      $(this).addClass('is-dragging');
    });
    $carousel.on('dragEnd.flickity', function() {
      $(this).removeClass('is-dragging');
    });
  }
});